import React, { useState, useEffect, useContext, useRef, useCallback, Suspense, useMemo } from 'react';
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { trainingSchedule } from './TrainingService';
import $ from 'jquery'
import { TostMsg } from '../../../../App';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom';
import { getEmployeeList } from '../../EmployeeList/Service/employeeService';
import { LazyImage } from '../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding';
import { GetMasterSystemAlert, uploadDoc } from '../../../../Services/Global-Services/GlobalServices';
import ERROR_LIST from '../../../../Services/Global-Services/Hadle_Errors';
const ComponentLoader = React.lazy(() => import('../../../../Shared/Sidebar/ComponentLoader'));

export default function ScheduleTraning() {
    const [loading, setLoading] = useState(false);
    const toster = useContext(TostMsg);
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const [videoPath, setVideoPath] = useState("/images/org-img/learn/add.png");
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
    const [file, setFile] = useState(null);
    const { id } = useParams();
    const navigate = useHistory()
    useEffect(() => {
        fetchEmployeeData();
    }, []);
    const [employee, setEmployee] = useState([]);
    const traningValidation = useMemo(()=> Yup.object().shape({
        title: Yup.string().required("Title is required."),
        startTime: Yup.string().required("Start time is required."),
        endTime: Yup.string().required("End time is required."),
        startDate: Yup.string().required("Start date is required."),
        // endDate: Yup.string().required("End date is required."),
        // slotCount: Yup.string().required("Slots is required."),
        // videoUrl: Yup.mixed().required('Video is required.')
        //     .test('fileFormat', 'Only mp4 are allowed', value => {
        //         if (value) {
        //             const supportedFormats = ["mp4"];
        //             return supportedFormats.includes(value.split('.').pop());
        //         }
        //         return true;
        //     }),
    }),[]);
    const traningForm = useFormik({
        initialValues: {
            title: '',
            startTime: '',
            endTime: '',
            startDate: '',
            // endDate: '',
            // slotCount: '',
            // videoUrl: ''
        },
        validationSchema: traningValidation,
        onSubmit:useCallback( async (data) => {
            setLoading(true);
            let prams = {
                "trainingId": id,
                "title": data.title,
                "startTime": data.startTime,
                "endTime": data.endTime,
                "startDate": new Date(data.startDate),
            }
            try {
                const reaponce = await trainingSchedule(prams);
                await GetMasterSystemAlertList('Training_Schedule_Added',0);
                navigate.push(`/InstructorTrainingDashboard/TrainingDetail/${id}`);                
                traningForm.resetForm();
                setVideoPath(null);
                setLoading(false);
            }
            catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
                setLoading(false);
            }
        },[])
    })
    //Get Employee List from EmployeeList service
     const fetchEmployeeData = useCallback(async()=> {
        setLoading(true);
        var params = {
            OrganisationId: userDetails?.OrgId,
            LoggedInEmployeeId: userDetails?.EmpId,
            IsDirectReportOrHierarchy: 0,
            SearchText: "",
            FollowersOnly: 0,
            FollowingsOnly: 0,
            IsExEmployeesAlso: 0,
            pageNumber: 1,
            pageSize: 10000,
            EmployeeId: 0,
        };
        try {
            let employeesList = await getEmployeeList(params);
            // let employeesList = await data.json();
            setEmployee(employeesList?.Data);
            setLoading(false);
        } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
            setLoading(false);
        }
    },[])

    const employeeOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <LazyImage alt={option.FullName} src={option.ProfileImage} />
                <span>{option.FullName}</span>
            </div>
        );
    };

    const SelectedEmployees = (event) => {
        traningForm.setFieldValue('instructorId', event.Id);
        traningForm.setFieldValue('hostName', event.FullName);
    }

    // Upload your feed image and video data
    const handleImageFileChange = useCallback(async (event) => {
        const selectedFile = await event.target.files[0];
        setFile(selectedFile);
    }, []);

    // Inner HTML for image
    const fileInputImageRef = useRef(null);
    function openFileImageInput() {
        fileInputImageRef.current.click();

    }

    useEffect(() => {
        if (file) {
            uploadPolicyDocFile();
        }
    }, [file]);
    // Upload your image and video data
    async function uploadPolicyDocFile() {
        setLoading(true)
        if (file) {
            const formData = new FormData();
            formData.append("files", file);
            try {
                const response = await uploadDoc(formData);
                const data = await response;
                setLoading(false);
                const ImageURL = data?.Data[0];
                $(".upload-img").hide("slow");
                $(".input-Btn").show("slow");
                await GetMasterSystemAlertList('File_Uploaded',0); 
                setLoading(false);
                setVideoPath(ImageURL)
                traningForm.setFieldValue('videoUrl', ImageURL);
                setFile(null);
            } catch (error) {
                setFile(null);
                setLoading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
            } finally {
                setFile(null);
                setLoading(false);
            }
        } else {
            setLoading(false);
            setFile(null);
            await GetMasterSystemAlertList('No_file_selected',2);
        }
    }

    const GetMasterSystemAlertList= useCallback(async(message, type)=> {	
        SystemAlerts?.filter((msg) => {
			if (msg?.Name == message && type == 0) {
				toster.current.success(msg?.Desc);
			} else if(msg?.Name == message && type == 1){
                toster.current.error(msg?.Desc);
            } else if(msg?.Name == message && type == 2){
				toster.current.warn(msg?.Desc);
			}
		});      
	},[]);


    return (
        <div className="position-relation">
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn">
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>
                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>
            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8 shrink-w">
                        <div className="form-head d-flex flex-wrap align-items-center mb-3">
                            <div className="me-auto">
                                <h2 className="font-w600 mb-0">Schedule Training</h2>
                                <p className="text-light">Lorem ipsum dolor sit amet</p>
                            </div>
                            <div className="rightside-tabs">
                                <Link to="/InstructorTrainingDashboard"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg></Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="col-xl-12">
                                    <div className="supp-req">
                                        <div className="addcourseform">
                                            <form onSubmit={traningForm.handleSubmit}>
                                                <span className="tagtitle">Title</span>
                                                <div className="row">
                                                    <div className="mb-4 col-md-12">
                                                        <input type="text" cols="1" rows="4" name='title'
                                                            className={"form-control bg-chng" + (traningForm.errors.title && traningForm.touched.title ? 'is-invalid' : '')}
                                                            onChange={traningForm.handleChange}
                                                            value={traningForm.values.title}
                                                            placeholder="Your Topic goes here..|" />
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.title && traningForm.touched.title ? traningForm.errors.title : null}
                                                        </div>
                                                    </div>
                                                    {/* <div className="mb-4 col-md-6">
                                                        <label className="form-label" >No Of Slot</label>
                                                        <input type="number" name='slotCount'
                                                            className={"form-control  h-auto" + (traningForm.errors.slotCount && traningForm.touched.slotCount ? 'is-invalid' : '')}
                                                            onChange={traningForm.handleChange}
                                                            value={traningForm.values.slotCount} />
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.slotCount && traningForm.touched.slotCount ? traningForm.errors.slotCount : null}
                                                        </div>
                                                    </div> */}
                                                    {/* <div className="mb-4 col-md-6">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <div onClick={() => { openFileImageInput() }} className="loadresumes"><div className="inner">
                                                                    <LazyVideo src={videoPath} className="w-100" />
                                                                    <span>
                                                                        Upload Video</span>
                                                                </div>
                                                                    <input type='file' ref={fileInputImageRef}
                                                                        style={{ display: "none" }} className="form-control" name='videoUrl' accept="video/*" onChange={handleImageFileChange} />
                                                                </div>
                                                                <div>{(traningForm.errors.videoUrl) ? <p style={{ color: 'red' }}>{traningForm.errors.videoUrl}</p> : null}</div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <div className="mb-4 col-md-12">
                                                        <label className="form-label">Start Date</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input id='txtDate' type="date" name='startDate'
                                                                min={new Date().toISOString().split('T')[0]}
                                                                className={"form-control  h-auto" + (traningForm.errors.startDate && traningForm.touched.startDate ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.startDate} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.startDate && traningForm.touched.startDate ? traningForm.errors.startDate : null}
                                                        </div>
                                                    </div>
                                                    {/* <div className="mb-4 col-md-6">
                                                        <label className="form-label">End Date</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input type="date" name='endDate' min={traningForm?.values?.startDate ? new Date(traningForm.values.startDate).toISOString().split('T')[0] : new Date()?.toISOString()?.split('T')[0]}
                                                                className={"form-control  h-auto" + (traningForm.errors.endDate && traningForm.touched.endDate ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.endDate} />
                                                            <div className="invalid-feedback">
                                                                {traningForm.errors.endDate && traningForm.touched.endDate ? traningForm.errors.endDate : null}
                                                            </div>
                                                        </div>
                                                        <label className="invalid-feedback">the end date is always greater than and equal to the start date.</label>
                                                    </div> */}
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">Duration From</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input type="time" name='startTime'
                                                                className={"form-control  h-auto" + (traningForm.errors.startTime && traningForm.touched.startTime ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.startTime} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.startTime && traningForm.touched.startTime ? traningForm.errors.startTime : null}
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">Duration To</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input type="time" name='endTime'
                                                                className={"form-control  h-auto" + (traningForm.errors.endTime && traningForm.touched.endTime ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.endTime} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.endTime && traningForm.touched.endTime ? traningForm.errors.endTime : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="btns-grp">
                                                        <button type='submit' className="savebtn-click">Save</button>
                                                        <button className="publish-click">Publish</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading ? <Suspense >
                <ComponentLoader />
            </Suspense> : ''}
        </div>
    )

}
